exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".r-personify-mc-pro .cls-1{fill:#411a50}.r-personify-mc-pro .cls-2{fill:#2b93d1}.r-personify-mc-pro .cls-3{fill:#5a4d63}", ""]);
